import { render, staticRenderFns } from "./HoraChart.vue?vue&type=template&id=b286e19e"
import script from "./HoraChart.vue?vue&type=script&lang=js"
export * from "./HoraChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports